import { getActiveSiteLogo } from "@/components/decorations/active-theme";
import { cn } from "@/lib/utils";
import Image from "next/image";

/** Header and footer wordmark. Seasonal logos keep the default logo's scale. */
export function SiteLogo({ className }: { className?: string }) {
  const logo = getActiveSiteLogo();
  const sized = Boolean(logo.displayHeight);

  return (
    <Image
      src={logo.src}
      alt="PlayMath.org Logo"
      width={logo.width}
      height={logo.height}
      className={cn(sized ? "w-auto max-w-none shrink-0" : "h-6 w-auto", className)}
      style={
        sized
          ? {
              height: logo.displayHeight,
              width: "auto",
              aspectRatio: `${logo.width} / ${logo.height}`,
            }
          : undefined
      }
    />
  );
}
